module.exports = __webpack_public_path__ + "img/A02.cd25727e.png";